const BRAND = 'flowdo';

/** Title-case words for unknown module names from the API */
function titleCaseWords(s) {
  if (!s) return '';
  return s
    .split(/\s+/)
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ''))
    .join(' ')
    .trim();
}

/**
 * Subscription line label: "flowdo Tasks (Plan display name)".
 * Brand stays lowercase; module segment is title-cased; plan name stays as returned by the API.
 */
export function formatFlowdoPlanWithModule(plan) {
  if (!plan) return '';
  const planName = (plan.display_name || plan.PlanName || plan.name || '').trim();
  const moduleRaw = (plan.Module?.display_name || plan.Module?.name || '').trim();
  const moduleLower = moduleRaw.toLowerCase();

  let modulePhrase = '';
  if (moduleLower.includes('document')) {
    modulePhrase = 'Documents';
  } else if (moduleLower.includes('task')) {
    modulePhrase = 'Tasks';
  } else if (moduleRaw) {
    modulePhrase = titleCaseWords(moduleRaw);
  }

  if (modulePhrase && planName) {
    return `${BRAND} ${modulePhrase} (${planName})`;
  }
  if (planName) {
    return `${BRAND} (${planName})`;
  }
  return `${BRAND} subscription`;
}

/** Product name only (no plan tier), from API module_id — 1 = Tasks, 2 = Documents */
export function formatFlowdoModuleOnly(moduleId) {
  const id = moduleId != null ? Number(moduleId) : NaN;
  if (id === 1) return `${BRAND} Tasks`;
  if (id === 2) return `${BRAND} Documents`;
  return null;
}
